<template>
  <div>
    <v-app>
      <v-data-table
        :headers="headers"
        :items="actions"
        :items-per-page="5"
        :sort-desc="[false, true]"
        hide-default-footer
        class="paginated-table table-striped"
      >
        <template v-slot:top>
          <v-btn tile small color="success" @click="showAddAction">
            <v-icon left> mdi-plus</v-icon>
            新增
          </v-btn>
        </template>
        <template v-slot:item.extendedPropertiesId="{ item }">{{
          getExtName(item.extendedPropertiesId)
        }}</template>
        <template v-slot:item.behaviorTypeId="{ item }">{{
          actImageMap[item.behaviorTypeId]
            ? actImageMap[item.behaviorTypeId].tit
            : ""
        }}</template>
        <template v-slot:item.option="{ item }">
          <md-button
            class="md-just-icon md-success md-round md-simple"
            @click.native="showEditAction(item)"
            style="padding-right: 30px"
          >
            <md-icon>edit</md-icon>
          </md-button>
          <md-button
            class="md-just-icon md-danger md-round md-simple"
            @click.native="delAction(index)"
          >
            <md-icon>close</md-icon>
          </md-button>
        </template>
      </v-data-table>
      <v-dialog v-model="showActDialog" hide-overlay scrollable max-width="80%">
        <v-form lazy-validation @submit.prevent="setAction">
          <v-card class="window-card">
            <v-card-title>
              <span class="md-title" style="color: #67ad5b">动作定义</span>
            </v-card-title>
            <v-card-text>
              <v-text-field
                v-model="form.name"
                label="动作名称*"
                :rules="[(v) => !!v || '动作名称不能为空']"
              ></v-text-field>
              <v-select
                v-model="form.extendedPropertiesId"
                :items="extDataList"
                item-text="name"
                item-value="id"
                label="属性*"
                :rules="[(v) => !!v || '属性不能为空']"
                hint="从扩展属性里选择相应的属性"
              ></v-select>
              <v-select
                v-model="form.behaviorTypeId"
                :items="behaviorTypeList"
                item-text="name"
                item-value="value"
                label="动作类型*"
                :loading="templateLoading"
                :rules="[(v) => !!v || '动作类型不能为空']"
                @change="changeTemplate"
              ></v-select>
              <div class="img-txt" v-if="actImageMap[form.behaviorTypeId]">
                <img
                  v-if="actImageMap[form.behaviorTypeId].img"
                  :src="
                    require('@/assets/img/' +
                      actImageMap[form.behaviorTypeId].img)
                  "
                  class="image-container"
                  alt=""
                />
                <span v-html="actImageMap[form.behaviorTypeId].txt"></span>
              </div>

              <v-row>
                <v-col
                  v-for="(item, index) in config"
                  :key="index"
                  class="d-flex"
                  :cols="item.Fields[0].cols ? item.Fields[0].cols : '12'"
                >
                  <!-- 文本域 -->
                  <v-text-field
                    v-if="item.Type === 'TextField'"
                    v-model="form[item.Fields[0].Code]"
                    :type="item.Fields[0].InputType"
                    :label="item.Fields[0].Label"
                    :rules="[
                      item.Fields[0].FieldRequired
                        ? (v) => !!v || `${item.Fields[0].Label}不能为空`
                        : false,
                    ]"
                  ></v-text-field>

                  <!-- 多行文本框 -->
                  <v-textarea
                    v-if="item.Type === 'Textareas'"
                    v-model="form[item.Fields[0].Code]"
                    :label="item.Fields[0].Label"
                    auto-grow
                    :rules="[
                      item.Fields[0].FieldRequired
                        ? (v) => !!v || `${item.Fields[0].Label}不能为空`
                        : false,
                    ]"
                  ></v-textarea>

                  <!-- 下拉框 -->
                  <v-select
                    v-if="item.Type === 'Selects'"
                    v-model="form[item.Fields[0].Code]"
                    :items="item.Fields[0].Options"
                    item-text="name"
                    item-value="value"
                    :label="item.Fields[0].Label"
                    :rules="[
                      item.Fields[0].FieldRequired
                        ? (v) => !!v || `${item.Fields[0].Label}不能为空`
                        : false,
                    ]"
                  ></v-select>

                  <!-- 单选框 -->
                  <div
                    v-if="item.Type === 'Radio'"
                    class="md-layout-item md-size-100 d-flex align-center"
                  >
                    <span v-if="item.Fields[0].Label" class="text-md"
                      >{{ item.Fields[0].Label }}：</span
                    >
                    <v-radio-group
                      v-model="form[item.Fields[0].Code]"
                      :row="!item.Fields[0].isColumn"
                      :column="item.Fields[0].isColumn"
                      :mandatory="item.Fields[0].FieldRequired"
                    >
                      <v-radio
                        v-for="o in item.Fields[0].Options"
                        :key="o.value"
                        :label="o.name"
                        :value="o.value"
                      ></v-radio>
                    </v-radio-group>
                  </div>
                  <!-- 开关 -->
                  <v-switch
                    v-if="item.Type === 'Switches'"
                    v-model="form[item.Fields[0].Code]"
                    :label="item.Fields[0].Label"
                    color="red darken-3"
                    class="d-inline-flex"
                  ></v-switch>

                  <!-- 坐标系 -->
                  <div
                    v-if="item.Type === 'Zb'"
                    class="md-layout-item md-size-100"
                  >
                    <span v-if="item.Fields[0].Label" class="text-md"
                      >{{ item.Fields[0].Label }}：</span
                    >
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="form[item.Fields[0].XCode]"
                          label="X"
                          :rules="[
                            item.Fields[0].FieldRequired
                              ? (v) => !!v || `${item.Fields[0].Label}X不能为空`
                              : false,
                          ]"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="form[item.Fields[0].YCode]"
                          label="Y"
                          :rules="[
                            item.Fields[0].FieldRequired
                              ? (v) => !!v || `${item.Fields[0].Label}Y不能为空`
                              : false,
                          ]"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="form[item.Fields[0].ZCode]"
                          label="Z"
                          :rules="[
                            item.Fields[0].FieldRequired
                              ? (v) => !!v || `${item.Fields[0].Label}Z不能为空`
                              : false,
                          ]"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </div>
                  <!-- 级联 -->
                  <div
                    v-if="item.Type === 'Cascader'"
                    class="md-layout-item md-size-100"
                  >
                    <v-row>
                      <v-col
                        v-for="(option, index2) in item.Fields"
                        :key="index2"
                        class="d-flex"
                        :cols="option.cols ? option.cols : '12'"
                      >
                        <v-select
                          v-if="option.Level === 1"
                          v-model="form[option.Code]"
                          :items="option.Options"
                          item-text="name"
                          item-value="value"
                          :label="option.Label"
                          :rules="[
                            option.FieldRequired
                              ? (v) => !!v || `${option.Label}不能为空`
                              : false,
                          ]"
                          @change="changeCascader(item, index2, $event)"
                        ></v-select>
                        <v-select
                          v-if="option.Level !== 1"
                          v-model="form[option.Code]"
                          :items="option.currOptions"
                          item-text="name"
                          item-value="value"
                          :label="option.Label"
                          :rules="[
                            option.FieldRequired
                              ? (v) => !!v || `${option.Label}不能为空`
                              : false,
                          ]"
                          @change="changeCascader(item, index2, $event)"
                        ></v-select>
                      </v-col>
                    </v-row>
                  </div>
                  <!--表格 -->
                  <div
                    v-if="item.Type === 'Table'"
                    class="tableCol"
                  >
                    <label style="width: 138px">
                      {{ item.Fields[0].Label }}
                    </label>
                    <div style="width: 100%;">
                      <v-data-table
                        :headers="item.Fields[0].Options"
                        :items="form[item.Fields[0].Code]"
                        :sort-desc="[false, true]"
                        hide-default-footer
                        class="paginated-table table-striped"
                      >
                        <template v-slot:top v-if="item.Fields[0].btns.includes('add')">
                          <v-btn tile small color="success" @click="showZbForm">
                            <v-icon left> mdi-plus</v-icon>
                            新增
                          </v-btn>
                        </template>
                        <template v-slot:item.option="{ row }" v-if="item.Fields[0].btns.includes('del')">
                          <md-button
                            class="md-just-icon md-danger md-round md-simple"
                            @click.native="handleDelete(row, item.Fields[0].Code)"
                          >
                            <md-icon>close</md-icon>
                          </md-button>
                        </template>
                      </v-data-table>
                    </div>
                  </div>
                </v-col>
              </v-row>
              <v-textarea
                auto-grow
                rows="1"
                v-model="form.description"
                label="描述"
                hint="请输入动作描述"
              ></v-textarea>
              <md-field>
                <label>相关资料</label>
                <md-file
                  multiple
                  v-model="form.files"
                  @md-change="onFileChange"
                />
                <ul class="files">
                  <li v-for="(item, index) of form.file" :key="'f' + index">
                    <a :href="item.url">{{ item.name }}</a>
                    <span @click="delFile(item, index)">x</span>
                  </li>
                </ul>
                <span class="md-helper-text"> 可上传多个文件</span>
              </md-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="success" type="submit">确 定</v-btn>
              <v-btn color="success" @click="showActDialog = false"
                >关 闭</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
      <v-dialog v-model="showAddDialog" hide-overlay scrollable max-width="80%">
        <v-form lazy-validation @submit.prevent="addTable">
          <v-card class="window-card">
            <v-card-title>
              <span class="md-title" style="color: #67ad5b">新增坐标</span>
            </v-card-title>
            <v-card-text>
              <v-text-field
                v-model="zbForm.attr"
                label="属性值*"
                :rules="[(v) => !!v || '属性值不能为空']"
                v-on:change="changeMap"
              ></v-text-field>
              <v-text-field
                v-model="zbForm.coordinate"
                label="移动坐标"
                hint="浮点数数组,保留两位小数,如:10.18,10.19,10.20"
                v-on:change="changeMap"
                type="text"
                v-if="form.behaviorTypeId === 'lsyd'"
              ></v-text-field>
              <v-text-field
                v-model="zbForm.rotationAngle"
                label="旋转角度"
                hint="浮点数数组,保留两位小数,如:10.18,10.19,10.20"
                v-on:change="changeMap"
                type="text"
                v-if="form.behaviorTypeId === 'lsxz'"
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="success" type="submit">确 定</v-btn>
              <v-btn color="success" @click="showAddDialog = false"
                >关 闭</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-app>
  </div>
</template>
<script>
import { upload } from "@/api/user";
import { allListActionTemplate } from "@/api/common";
export default {
  name: "ActTab",
  props: {
    extDataList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      headers: [
        { text: "名称", align: "center", value: "name" },
        { text: "属性", align: "center", value: "extendedPropertiesId" },
        { text: "类型", align: "center", value: "behaviorTypeId" },
        { text: "编辑", align: "center", value: "option", width: "100px" },
      ],
      showActDialog: false,
      showAddDialog: false,
      form: {},
      zbForm: {},
      actions: [],
      behaviorTypeList: [],
      actImageMap: {
        zdh: {
          img: "gif1.gif",
          txt: "<li>3DMax输出的Animation文件</li><li>帧名称填写动画名称</li>",
          tit: "帧动画",
        },
        lxxz: {
          img: "gif2.gif",
          txt: "<li>匀速从起始角度旋转至目标角度</li><li>选择旋转方向</li><li>属性范围与角度范围起始匹配</li>",
          tit: "连续旋转",
        },
        lsxz: {
          img: "gif3.gif",
          txt: "<li>有限个旋转目标点</li><li>选择旋转方向</li><li>每个属性值匹配一个旋转目标点角度</li>",
          tit: "离散旋转",
        },
        lxyd: {
          img: "gif4.gif",
          txt: "<li>匀速从起始位置移动至目标位置</li><li>选择移动方向</li><li>属性范围和坐标范围起始匹配</li>",
          tit: "连续移动",
        },
        lsyd: {
          img: "gif5.gif",
          txt: "<li>有限个移动目标点</li><li>选择移动方向</li><li>每个属性值匹配一个目标位置</li>",
          tit: "离散移动",
        },
        bxdh: {
          img: "gif6.gif",
          txt: "<li>允许拉升、缩小至目标大小</li><li>选择缩放方向</li><li>属性范围和拉升范围其实匹配</li>",
          tit: "变形动画",
        },
        zdy: {
          img: "",
          txt: "<li>自定义选择</li>",
          tit: "自定义",
        },
      },
      // 动作模板列加载显示
      templateLoading: false,
      // 当前数据模板配置
      config: [],
    };
  },
  mounted() {
    this.initForm();
    this.templateLoading = true;
    allListActionTemplate({
      template_type: "device",
      belongTo_code: "actionDefine-device",
    }).then((res) => {
      this.templateLoading = false;
      if (res.code === "200") {
        // actionList 返回的数据动作模板（未作处理的）
        this.actionList = res.data.rows;
        this.behaviorTypeList = res.data.rows.map((item) => {
          return {
            value: item.template_code,
            name: item.name,
          };
        });
      }
    });
  },
  methods: {
    getExtName(id) {
      return this.extDataList.find((item) => item.id === id).name;
    },
    init(form) {
      if (typeof form === "object") {
        this.actions = form;
      }
    },
    initForm() {
      this.form = {
        name: "",
        description: "",
        extendedPropertiesId: "",
        behaviorTypeId: "",
        zdh_name: "",
        rate: "",
        direction: "",
        moveData: [],
        propertyRange: [],
        angleRange: [],
        moveRange: [],
        proportion: "",
        rotData: [],
        file: [],
        files: "",
      };
    },
    showAddAction() {
      this.showActDialog = true;
      this.initForm();
    },
    addTable() {
      const dict = {
        lsxz: "rotData",
        lsyd: "moveData",
      };
      this.form[dict[this.form.behaviorTypeId]].push(this.zbForm);
      this.showAddDialog = false;
    },
    showZbForm() {
      this.showAddDialog = true;
      this.zbForm = {};
    },
    changeMap() {
      this.form.isChange = true;
    },
    onFileChange(files) {
      if (!files.length) return;
      this.createImage(files[0]);
    },
    handleDelete(index, keyName) {
      this.form[keyName].splice(index, 1);
    },
    createImage(file) {
      this.form.files = "";
      let reader = new FileReader();
      reader.onload = (e) => {
        // this.user.avatar = e.target.result;
      };
      reader.readAsDataURL(file);
      let formData = new FormData();
      formData.append("deviceFile", file);
      // let params = configApi.upload(formData)
      // params.headers = {
      //   'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundarynl6gT1BKdPWIejNq'
      // }
      // api
      //   .$axios(params)
      //   .then((res) => {
      //     if (res.data.code === '200') {
      //       // this.basicPropertyMap.icon = res.data.data.url;
      //       this.form.file.push(res.data.data)
      //       this.$message.success('上传成功')
      //       this.form.files = ''
      //     }
      //   })
      //   .catch(() => {})
      upload(formData).then((res) => {
        if (res.code === "200") {
          this.form.file.push(res.data);
          this.$message.success("上传成功");
          this.form.files = "";
        }
      });
    },
    setAction() {
      if (this.form.id) {
        const actIndex = this.actions.findIndex(
          (item) => item.id === this.form.id
        );
        this.actions[actIndex] = this.form;
      } else {
        this.form.id = `device_act_${new Date().getTime()}`;
        this.actions.push(this.form);
      }
      this.initForm();
      this.showActDialog = false;
    },
    showEditAction(item) {
      this.form = item;
      this.showActDialog = true;
    },
    delAction(index) {
      this.actions.splice(index, 1);
    },
    /**
     * 改变模板配置
     */
    changeTemplate(e) {
      // 过滤掉不需要的属性
      this.form = (({
        name,
        extendedPropertiesId,
        behaviorTypeId,
        description,
        files,
      }) => ({
        name,
        extendedPropertiesId,
        behaviorTypeId,
        description,
        files,
      }))(this.form);
      const list = this.actionList.filter((item) => {
        return item.template_code === e;
      });
      this.config = JSON.parse(list[0].config);
      // 设置默认值
      this.$nextTick(() => {
        this.config.forEach((item) => {
          item.Fields.forEach((f) => {
            if (item.Type === "Zb") {
              this.$set(this.form, f.XCode, f.XDefaultVal);
              this.$set(this.form, f.YCode, f.YDefaultVal);
              this.$set(this.form, f.ZCode, f.ZDefaultVal);
            } else {
              this.$set(this.form, f.Code, f.DefaultVal);
            }
          });
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.tableCol {
    display: flex;
    flex-wrap: nowrap;
    align-content: space-between;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    width: 100%;
}
.v-data-table {
    width: 100%;
}
</style>